export default "__VITE_ASSET__nR8Ju9au__"